module.exports = __webpack_public_path__ + "img/P30-zh.843badef.png";